import Camera from './Camera'
import ManualHairTypeSelector from './ManualHairTypeSelector'
import PhotoPreviewActions from './PhotoPreviewActions'
import PhotoSourceSelector from './PhotoSourceSelector'

const PhotoUploadPanel = ({
  showCamera,
  showManualHairTypeGrid,
  photoPreview,
  fileInputRef,
  hairTypeOptions,
  onCapture,
  onUploadClick,
  onTakePicture,
  onSelectHairType,
  onBackFromHairType,
  onHairTypeSelect,
  onRemovePhoto,
  onSendPhoto,
  onFileChange,
  translations = {},
  language = 'EN',
}) => {
  return (
    <div className='chat-input-inner' style={{ padding: '0 16px' }}>
      {showCamera ? (
        <div style={{ marginTop: '10px' }}>
          <Camera mode='chat' onCapture={onCapture} />
        </div>
      ) : (
        <div className='upload-zone'>
          {!photoPreview ? (
            <>
              {showManualHairTypeGrid ? (
                <ManualHairTypeSelector
                  options={hairTypeOptions || []}
                  onSelect={onHairTypeSelect}
                  onBack={onBackFromHairType}
                  translations={translations}
                  language={language}
                />
              ) : (
              <PhotoSourceSelector
                onUpload={onUploadClick}
                onTakePicture={onTakePicture}
                onSelectHairType={onSelectHairType}
                translations={translations}
                language={language}
              />
              )}
            </>
          ) : (
          <PhotoPreviewActions
            photoPreview={photoPreview}
            onRemove={onRemovePhoto}
            onSend={onSendPhoto}
            translations={translations}
            language={language}
          />
          )}
        </div>
      )}

      <input
        ref={fileInputRef}
        type='file'
        accept='image/*'
        style={{ display: 'none' }}
        onChange={onFileChange}
      />
    </div>
  )
}

export default PhotoUploadPanel
